import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/kingKongArea',
  component: LAYOUT,
  name: 'KingKongArea',
  redirect: '/kingKongArea/detail',
  meta: {
    title: '金刚区',
  },
  children: [
    {
      path: 'detail',
      name: 'KingKongAreaDetail',
      meta: {
        title: '车型参数配置',
      },
      component: () => import('@/views/kingKongArea/detail'),
    },
  ],
};
